module.exports = __webpack_public_path__ + "img/Group 411.5cdc0a94.svg";